var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-pagination" }, [
    _c("div", { staticClass: "app-pagination__info" }, [
      _c("span", { staticClass: "app-pagination__showing" }, [
        _vm._v(
          "Showing " +
            _vm._s(_vm.startItem) +
            "-" +
            _vm._s(_vm.endItem) +
            " of " +
            _vm._s(_vm.total)
        )
      ]),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "app-pagination__rows" },
        [
          _c("span", { staticClass: "app-pagination__rows-label" }, [
            _vm._v("Rows per page")
          ]),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "app-pagination__size-select",
              attrs: { size: "mini", value: _vm.pageSize },
              on: { change: _vm.onSizeChange }
            },
            _vm._l(_vm.pageSizes, function(size) {
              return _c("el-option", {
                key: size,
                attrs: { label: size, value: size }
              })
            }),
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "app-pagination__pager" },
      [
        _c(
          "button",
          {
            staticClass: "app-pagination__nav",
            attrs: { type: "button", disabled: _vm.currentPage <= 1 },
            on: {
              click: function($event) {
                return _vm.onCurrentChange(_vm.currentPage - 1)
              }
            }
          },
          [_vm._v("«")]
        ),
        _vm._v(" "),
        _vm._l(_vm.pagerItems, function(item) {
          return _c(
            "button",
            {
              key: item.key,
              staticClass: "app-pagination__page",
              class: {
                "is-active": !item.ellipsis && item.page === _vm.currentPage,
                "is-ellipsis": item.ellipsis
              },
              attrs: { type: "button", disabled: item.ellipsis },
              on: {
                click: function($event) {
                  !item.ellipsis && _vm.onCurrentChange(item.page)
                }
              }
            },
            [_vm._v(_vm._s(item.ellipsis ? "…" : item.page))]
          )
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "app-pagination__nav",
            attrs: {
              type: "button",
              disabled: _vm.currentPage >= _vm.pageCount
            },
            on: {
              click: function($event) {
                return _vm.onCurrentChange(_vm.currentPage + 1)
              }
            }
          },
          [_vm._v("»")]
        )
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-91add832", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91add832","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/AppPagination.vue
// module id = null
// module chunks = 